/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/comma-dangle */
export const HeaderVariants = {
    header1Bold: '1',
    header1: '1',
    header2Bold: '2',
    header2: '2',
    header3Bold: '3',
    header3: '3',
    header4Bold: '4',
    header4: '4',
    brandH4: '4',
};
export var FontVariantToken;
(function (FontVariantToken) {
    FontVariantToken["fontSizeHeroBold"] = "heroBold";
    FontVariantToken["fontSizeHero"] = "hero";
    FontVariantToken["fontSizeH1Bold"] = "header1Bold";
    FontVariantToken["fontSizeH1"] = "header1";
    FontVariantToken["fontSizeH2Bold"] = "header2Bold";
    FontVariantToken["fontSizeH2"] = "header2";
    FontVariantToken["fontSizeH3Bold"] = "header3Bold";
    FontVariantToken["fontSizeH3"] = "header3";
    FontVariantToken["fontSizeH4Bold"] = "header4Bold";
    FontVariantToken["fontSizeH4"] = "header4";
    FontVariantToken["fontSizeLBold"] = "lBold";
    FontVariantToken["fontSizeL"] = "l";
    FontVariantToken["fontSizeMBold"] = "mBold";
    FontVariantToken["fontSizeM"] = "m";
    FontVariantToken["fontSizeLink"] = "link";
    FontVariantToken["fontSizeSBold"] = "sBold";
    FontVariantToken["fontSizeS"] = "s";
    FontVariantToken["fontSizeXsBold"] = "xsBold";
    FontVariantToken["fontSizeXs"] = "xs";
    FontVariantToken["fontBrandH4"] = "brandH4";
    FontVariantToken["fontBrandL"] = "brandL";
    FontVariantToken["fontBrandM"] = "brandM";
    FontVariantToken["fontMonoMBold"] = "monoMBold";
    FontVariantToken["fontMonoM"] = "monoM";
    FontVariantToken["fontMonoSBold"] = "monoSBold";
    FontVariantToken["fontMonoS"] = "monoS";
    FontVariantToken["fontMonoXSBold"] = "monoXSBold";
    FontVariantToken["fontMonoXS"] = "monoXS";
})(FontVariantToken || (FontVariantToken = {}));
export const fontSizeHeroBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '60px',
    'lineHeight': '72px',
    'fontWeight': 400
};
export const fontSizeHero = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '60px',
    'lineHeight': '72px',
    'fontWeight': 300
};
export const fontSizeH1Bold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '36px',
    'lineHeight': '44px',
    'fontWeight': 400
};
export const fontSizeH1 = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '36px',
    'lineHeight': '44px',
    'fontWeight': 300
};
export const fontSizeH2Bold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '32px',
    'lineHeight': '40px',
    'fontWeight': 400
};
export const fontSizeH2 = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '32px',
    'lineHeight': '40px',
    'fontWeight': 300
};
export const fontSizeH3Bold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '24px',
    'lineHeight': '32px',
    'fontWeight': 700
};
export const fontSizeH3 = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '24px',
    'lineHeight': '24px',
    'fontWeight': 400
};
export const fontSizeH4Bold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '20px',
    'lineHeight': '24px',
    'fontWeight': 600
};
export const fontSizeH4 = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '20px',
    'lineHeight': '24px',
    'fontWeight': 400
};
export const fontSizeLBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '16px',
    'lineHeight': '24px',
    'fontWeight': 600
};
export const fontSizeL = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '16px',
    'lineHeight': '24px',
    'fontWeight': 400
};
export const fontSizeMBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 600
};
export const fontSizeM = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 400
};
export const fontSizeLink = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 600
};
export const fontSizeSBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '12px',
    'lineHeight': '16px',
    'fontWeight': 600
};
export const fontSizeS = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '12px',
    'lineHeight': '16px',
    'fontWeight': 400
};
export const fontSizeXsBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '10px',
    'lineHeight': '16px',
    'fontWeight': 600
};
export const fontSizeXs = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '10px',
    'lineHeight': '16px',
    'fontWeight': 400
};
export const fontBrandH4 = {
    'fontFamily': 'poppins, noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\', \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '20px',
    'lineHeight': '24px',
    'letterSpacing': '-0.528px',
    'fontWeight': 600
};
export const fontBrandL = {
    'fontFamily': 'poppins, noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\', \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '16px',
    'lineHeight': '24px',
    'fontWeight': 600
};
export const fontBrandM = {
    'fontFamily': 'poppins, noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\', \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '14px',
    'lineHeight': '24px',
    'fontWeight': 500
};
export const fontMonoMBold = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 700
};
export const fontMonoM = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 400
};
export const fontMonoSBold = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '12px',
    'lineHeight': '16px',
    'fontWeight': 700
};
export const fontMonoS = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '12px',
    'lineHeight': '16px',
    'fontWeight': 400
};
export const fontMonoXSBold = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '10px',
    'lineHeight': '16px',
    'fontWeight': 700
};
export const fontMonoXS = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '10px',
    'lineHeight': '16px',
    'fontWeight': 400
};
